(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["callista-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // ── SLIDER MEDIA ──────────────────────────────────────────
    const slider = document.querySelector('.media_prodotto');
    if (slider) {
      let isDown = false;
      let startY = 0;
      let scrollTop = 0;
      let hasDragged = false;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        hasDragged = false;
        startY = e.clientY;
        scrollTop = slider.scrollTop;
        slider.classList.add('is-dragging');
      });

      document.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const delta = e.clientY - startY;
        if (Math.abs(delta) > 3) hasDragged = true;
        const newScroll = scrollTop - delta;
        const maxScroll = slider.scrollHeight - slider.clientHeight;
        slider.scrollTop = Math.max(0, Math.min(newScroll, maxScroll));
      });

      slider.addEventListener(
        'click',
        (e) => {
          if (hasDragged) e.stopPropagation();
        },
        true
      );

      let touchStartY = 0;
      let touchScrollTop = 0;

      slider.addEventListener(
        'touchstart',
        (e) => {
          touchStartY = e.touches[0].clientY;
          touchScrollTop = slider.scrollTop;
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchmove',
        (e) => {
          const delta = touchStartY - e.touches[0].clientY;
          slider.scrollTop = touchScrollTop + delta;
        },
        { passive: true }
      );
    }

    // ── TAB METAFIELDS ──────────────────────────────────────────
    document.querySelectorAll('.metafield-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        const index = this.dataset.index;

        document.querySelectorAll('.metafield-tab').forEach(function (t) {
          t.classList.remove('active');
        });

        // ── MODIFICA: reset dei panel con la nuova struttura ──
        document.querySelectorAll('.metafield-panel').forEach(function (p) {
          p.hidden = true;
          var content = p.querySelector('.metafield-content');
          var btnPiu = p.querySelector('.metafield-leggi-piu');
          var btnMeno = p.querySelector('.metafield-leggi-meno');
          if (content) content.classList.remove('is-expanded');
          if (btnPiu) btnPiu.hidden = false;
          if (btnMeno) btnMeno.hidden = true;
        });

        this.classList.add('active');
        document.querySelector('.metafield-panel[data-index="' + index + '"]').hidden = false;
        aggiornaBottoniLeggiDiPiu();
      });
    });

    // ── LEGGI DI PIÙ ──────────────────────────────────────────
    // ── MODIFICA: aggiunge is-expanded invece di swappare preview/full ──
    document.querySelectorAll('.metafield-leggi-piu').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = this.closest('.metafield-panel');
        panel.querySelector('.metafield-content').classList.add('is-expanded');
        panel.querySelector('.metafield-leggi-piu').hidden = true;
        panel.querySelector('.metafield-leggi-meno').hidden = false;
      });
    });

    // ── LEGGI DI MENO ──────────────────────────────────────────
    // ── MODIFICA: rimuove is-expanded invece di swappare preview/full ──
    document.querySelectorAll('.metafield-leggi-meno').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = this.closest('.metafield-panel');
        panel.querySelector('.metafield-content').classList.remove('is-expanded');
        panel.querySelector('.metafield-leggi-piu').hidden = false;
        panel.querySelector('.metafield-leggi-meno').hidden = true;
      });
    });

    // ── SCOPRI I PASSAGGI ──────────────────────────────────────────
    document.querySelectorAll('.metafield-scopri-passaggi').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var popup = document.getElementById('popup-info-come-parrucca');
        if (popup) popup.hidden = false;
      });
    });

    // ── LEGGI DI PIÙ: mostra il bottone solo se il testo è troncato ──
    function aggiornaBottoniLeggiDiPiu() {
      if (window.innerWidth <= 749) return;

      document.querySelectorAll('.metafield-panel:not([data-key="come_si_indossa"])').forEach(function (panel) {
        // ── salta i panel nascosti, non hanno dimensioni ──
        if (panel.hidden) return;

        var content = panel.querySelector('.metafield-content');
        var btnPiu = panel.querySelector('.metafield-leggi-piu');
        if (!content || !btnPiu) return;

        if (content.scrollHeight <= content.clientHeight) {
          btnPiu.hidden = true;
        } else {
          btnPiu.hidden = false;
        }
      });
    }

    // ── QUANTITÀ ──────────────────────────────────────────
    var quantita = 1;
    var quantitaValore = document.getElementById('quantita-valore');
    var quantitaMeno = document.getElementById('quantita-meno');
    var quantitaPiu = document.getElementById('quantita-piu');

    if (quantitaMeno && quantitaPiu) {
      quantitaMeno.addEventListener('click', function () {
        if (quantita > 1) {
          quantita--;
          quantitaValore.textContent = quantita;
          aggiornaPrezzo();
        }
      });

      quantitaPiu.addEventListener('click', function () {
        quantita++;
        quantitaValore.textContent = quantita;
        aggiornaPrezzo();
      });
    }

    // ── VARIANTI + PREZZO ──────────────────────────────────────────
    var variantiContainer = document.querySelector('.varianti_prodotto');
    if (variantiContainer) {
      var variantData = JSON.parse(variantiContainer.dataset.variants);
      var selectedOptions = {};

      document.querySelectorAll('.variante_gruppo').forEach(function (gruppo) {
        var firstBtn = gruppo.querySelector('.variante-btn.active');
        if (firstBtn) {
          selectedOptions[firstBtn.dataset.optionIndex] = firstBtn.dataset.value;
        }
      });

      function aggiornaPrezzo() {
        var selectedVariant = variantData.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i + 1];
          });
        });
        if (!selectedVariant) return;
        var totale = (selectedVariant.price * quantita) / 100;
        document.getElementById('prezzo-totale').textContent = totale.toLocaleString('it-IT', {
          style: 'currency',
          currency: 'EUR',
        });
      }

      aggiornaPrezzo();

      document.querySelectorAll('.variante-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optionIndex = this.dataset.optionIndex;

          document.querySelectorAll('.variante-btn[data-option-index="' + optionIndex + '"]').forEach(function (b) {
            b.classList.remove('active');
          });
          this.classList.add('active');
          selectedOptions[optionIndex] = this.dataset.value;
          aggiornaPrezzo();
        });
      });

      document.getElementById('add-to-cart-btn').addEventListener('click', function () {
        var selectedVariant = variantData.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i + 1];
          });
        });

        if (!selectedVariant) return;
        if (!selectedVariant.available) {
          alert('Variante non disponibile');
          return;
        }

        // fetch('/cart/add.js', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ id: selectedVariant.id, quantity: quantita }),
        // })
        //   .then(function (res) {
        //     return res.json();
        //   })
        //   .then(function () {
        //     document.dispatchEvent(new CustomEvent('cart:open'));
        //   })
        //   .catch(function (err) {
        //     console.error(err);
        //   });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selectedVariant.id, quantity: quantita }),
        })
          // .then(function (res) {
          //   return res.json();
          // })
          // .then(function () {
          //   // ← sostituisci document.dispatchEvent(new CustomEvent('cart:open')) con questo:
          //   var drawer = document.querySelector('cart-drawer-component');
          //   if (drawer) drawer.open();
          // })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  data: {
                    source: 'product-form-component',
                    itemCount: quantita,
                  },
                },
              })
            );
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer) drawer.open();
          })
          .catch(function (err) {
            console.error(err);
          });
      });
    }

    // ── CAROSELLO MOBILE ──────────────────────────────────────────
    function initCarosello() {
      if (window.innerWidth > 749) return;

      var sliderMobile = document.querySelector('.media_prodotto');
      if (!sliderMobile) return;

      var items = sliderMobile.querySelectorAll('.media_prodotto__item, .media_prodotto__item--video');
      if (items.length <= 1) return;

      sliderMobile.style.position = 'relative';
      sliderMobile.style.overflow = 'hidden';
      sliderMobile.style.flexDirection = 'row';

      var current = 0;
      var autoplayTimer = null;

      items.forEach(function (item, i) {
        item.style.display = i === 0 ? 'block' : 'none';
        item.style.width = '100%';
        item.style.flexShrink = '0';
      });

      var dotsContainer = document.createElement('div');
      dotsContainer.className = 'carosello-dots';
      items.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'carosello-dot' + (i === 0 ? ' active' : '');
        dot.type = 'button';
        dot.addEventListener('click', function () {
          goTo(i);
          resetAutoplay();
        });
        dotsContainer.appendChild(dot);
      });
      sliderMobile.appendChild(dotsContainer);

      function goTo(index) {
        items[current].style.display = 'none';
        dotsContainer.querySelectorAll('.carosello-dot')[current].classList.remove('active');

        if (index >= items.length) index = 0;
        if (index < 0) index = items.length - 1;

        current = index;
        items[current].style.display = 'block';
        dotsContainer.querySelectorAll('.carosello-dot')[current].classList.add('active');
      }

      function startAutoplay() {
        autoplayTimer = setInterval(function () {
          goTo(current + 1);
        }, 3000);
      }

      function resetAutoplay() {
        clearInterval(autoplayTimer);
        startAutoplay();
      }

      startAutoplay();

      var touchStartX = 0;
      sliderMobile.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.touches[0].clientX;
          clearInterval(autoplayTimer);
        },
        { passive: true }
      );

      sliderMobile.addEventListener(
        'touchend',
        function (e) {
          var diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) goTo(current + 1);
            if (diff < 0) goTo(current - 1);
          }
          resetAutoplay();
        },
        { passive: true }
      );
    }

    initCarosello();
    requestAnimationFrame(aggiornaBottoniLeggiDiPiu);

    // ── SCROLL LOCK MEDIA (solo desktop) ──────────────────────────────────────────
    function initScrollLockMedia() {
      if (window.innerWidth <= 749) return;

      var media = document.querySelector('.media_prodotto');
      var inner = document.querySelector('.caratteristiche_prodotto__inner');
      var infoProdotto = document.querySelector('.info_prodotto');
      if (!media || !infoProdotto) return;

      var locked = false;

      function isMediaScrollable() {
        return media.scrollHeight > media.clientHeight + 2;
      }

      function checkLock() {
        // Calcola se .info_prodotto è nella viewport
        var rect = infoProdotto.getBoundingClientRect();
        var inView = rect.top <= 10 && rect.bottom >= window.innerHeight - 10;

        var atBottom = Math.abs(media.scrollHeight - media.clientHeight - media.scrollTop) < 2;
        var atTop = media.scrollTop <= 0;

        // Blocca solo se: siamo sulla sezione, il media è scrollabile, e non siamo già ai limiti
        if (inView && isMediaScrollable()) {
          locked = true;
        } else {
          locked = false;
        }

        return { atBottom, atTop };
      }

      window.addEventListener(
        'wheel',
        function (e) {
          var popup = document.getElementById('popup-info-come-parrucca');
          if (popup && !popup.hidden) return;

          var { atBottom, atTop } = checkLock();

          if (!locked) return;

          var goingDown = e.deltaY > 0;
          var goingUp = e.deltaY < 0;

          // Se media non è in fondo (scroll down) → cattura
          if (goingDown && !atBottom) {
            e.preventDefault();
            media.scrollTop += e.deltaY;
            if (inner) inner.scrollTop += e.deltaY;
            return;
          }

          // Se media non è in cima (scroll up) → cattura
          if (goingUp && !atTop) {
            e.preventDefault();
            media.scrollTop += e.deltaY;
            if (inner) inner.scrollTop += e.deltaY;
            return;
          }

          // Altrimenti lascia passare lo scroll normalmente
        },
        { passive: false }
      );
    }

    initScrollLockMedia();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var popupParrucca = document.getElementById('popup-info-come-parrucca');
    var iconInfoBtnParrucca = document.getElementById('icon-info-come-parrucca');
    var popupCloseParrucca = document.querySelector('#popup-info-come-parrucca .popup-close');

    if (iconInfoBtnParrucca && popupParrucca && popupCloseParrucca) {
      iconInfoBtnParrucca.addEventListener('click', function () {
        popupParrucca.hidden = false;
      });
      popupCloseParrucca.addEventListener('click', function () {
        popupParrucca.hidden = true;
      });
      popupParrucca.addEventListener('click', function (e) {
        if (e.target === popupParrucca) popupParrucca.hidden = true;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collezione"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stato = { colore: 'all', taglio: 'all' };

    function aggiornaOpzioniDropdown(tipoModificato) {
      const altroTipo = tipoModificato === 'colore' ? 'taglio' : 'colore';
      const cards = document.querySelectorAll('.prodotto_card');
      const tagsDisponibili = new Set();

      cards.forEach(function (card) {
        const tags = card.dataset.tags.split(',').map(function (t) {
          return t.trim();
        });
        const passaFiltro = stato[tipoModificato] === 'all' || tags.includes(stato[tipoModificato]);
        if (passaFiltro) {
          tags.forEach(function (tag) {
            if (tag.startsWith(altroTipo + '_')) tagsDisponibili.add(tag);
          });
        }
      });

      document
        .getElementById('lista-' + altroTipo)
        .querySelectorAll('.dropdown-option')
        .forEach(function (opt) {
          opt.style.display = tagsDisponibili.has(opt.dataset.value) ? '' : 'none';
        });

      // se il valore attualmente selezionato nell'altro filtro non è più disponibile, resettalo
      if (stato[altroTipo] !== 'all' && !tagsDisponibili.has(stato[altroTipo])) {
        stato[altroTipo] = 'all';
        aggiornaChip(altroTipo);
      }
    }

    function filtra() {
      const cards = document.querySelectorAll('.prodotto_card');
      let visibili = 0;

      cards.forEach(function (card) {
        const tags = card.dataset.tags.split(',').map(function (t) {
          return t.trim();
        });
        const passaColore = stato.colore === 'all' || tags.includes(stato.colore);
        const passaTaglio = stato.taglio === 'all' || tags.includes(stato.taglio);
        const mostra = passaColore && passaTaglio;
        card.style.display = mostra ? '' : 'none';
        if (mostra) visibili++;
      });

      document.getElementById('nessun-prodotto').hidden = visibili > 0;
    }

    function chiudiTutti() {
      ['colore', 'taglio'].forEach(function (tipo) {
        const lista = document.getElementById('lista-' + tipo);
        const dropdown = document.getElementById('dropdown-' + tipo);
        if (lista) lista.hidden = true;
        if (dropdown) dropdown.classList.remove('aperto');
      });
    }

    function apriDropdown(tipo) {
      chiudiTutti();
      const lista = document.getElementById('lista-' + tipo);
      const dropdown = document.getElementById('dropdown-' + tipo);
      const trigger = dropdown.querySelector('.dropdown-trigger');

      // calcola se aprire sopra o sotto
      const rect = trigger.getBoundingClientRect();
      const spazioSotto = window.innerHeight - rect.bottom;
      const spazioSopra = rect.top;
      const altezzaLista = 200;

      lista.classList.remove('apri-sotto', 'apri-sopra');
      if (spazioSotto >= altezzaLista || spazioSotto >= spazioSopra) {
        lista.classList.add('apri-sotto');
      } else {
        lista.classList.add('apri-sopra');
      }

      lista.hidden = false;
      dropdown.classList.add('aperto');
    }

    function aggiornaChip(tipo) {
      const chip = document.getElementById('chip-' + tipo);
      const chipLabel = document.getElementById('chip-label-' + tipo);
      const dropdown = document.getElementById('dropdown-' + tipo);
      const label = dropdown.querySelector('.dropdown-label');

      if (stato[tipo] === 'all') {
        chip.hidden = true;
        dropdown.hidden = false;
        label.textContent = tipo.toUpperCase() + ': ALL';
      } else {
        const valore = stato[tipo].replace(tipo + '_', '').replace(/_/g, ' ');
        chipLabel.textContent = tipo.toUpperCase() + ': ' + valore.toUpperCase();
        chip.hidden = false;
        dropdown.hidden = true;
      }
    }

    ['colore', 'taglio'].forEach(function (tipo) {
      const trigger = document.querySelector('#dropdown-' + tipo + ' .dropdown-trigger');
      const lista = document.getElementById('lista-' + tipo);
      const reset = document.getElementById('reset-' + tipo);

      trigger.addEventListener('click', function () {
        if (!lista.hidden) {
          chiudiTutti();
        } else {
          apriDropdown(tipo);
        }
      });

      lista.querySelectorAll('.dropdown-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          stato[tipo] = this.dataset.value;
          chiudiTutti();
          aggiornaChip(tipo);
          aggiornaOpzioniDropdown(tipo);
          filtra();
        });
      });

      reset.addEventListener('click', function () {
        stato[tipo] = 'all';
        aggiornaChip(tipo);
        aggiornaOpzioniDropdown(tipo);
        filtra();
      });
    });

    // chiudi cliccando fuori
    document.addEventListener('click', function (e) {
      const dentroDropdown = e.target.closest('.dropdown') || e.target.closest('.filtro-chip');
      if (!dentroDropdown) chiudiTutti();
    });

    // Hover cycling immagini
    document.querySelectorAll('.card-prodotto__immagini').forEach(function (card) {
      const img = card.querySelector('.card-prodotto__img');
      const originalSrc = img.getAttribute('src');
      const originalSrcset = img.getAttribute('srcset') || '';
      let images = [];
      let interval = null;
      let index = 0;

      try {
        const raw = card.dataset.images.replace(/&amp;/g, '&');
        images = raw.split(',').map(function (url) {
          return url.trim();
        });
      } catch (e) {
        return;
      }

      if (images.length <= 1) return;

      card.addEventListener('mouseenter', function () {
        index = 1;
        img.srcset = '';
        img.src = images[index];
        interval = setInterval(function () {
          index = (index + 1) % images.length;
          img.srcset = '';
          img.src = images[index];
        }, 200);
      });

      card.addEventListener('mouseleave', function () {
        clearInterval(interval);
        img.srcset = originalSrcset;
        img.src = originalSrc;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function apriChiudi(item) {
      var risposta = item.querySelector('.faq-risposta');
      var toggle = item.querySelector('.faq-toggle');

      if (item.classList.contains('open')) {
        risposta.style.maxHeight = '0';
        item.classList.remove('open');
        toggle.textContent = '+';
      } else {
        item.classList.add('open');
        risposta.style.maxHeight = risposta.scrollHeight + 'px';
        toggle.textContent = '−';
      }
    }

    document.addEventListener('click', function (e) {
      var domanda = e.target.closest('.faq-domanda');
      var risposta = e.target.closest('.faq-risposta');

      if (domanda) apriChiudi(domanda.closest('.faq-item'));
      if (risposta) apriChiudi(risposta.closest('.faq-item'));
    });
  })();

  document.addEventListener('click', function (e) {
    var domanda = e.target.closest('.faq-domanda');
    var risposta = e.target.closest('.faq-risposta');
    var item = e.target.closest('.faq-item');

    if (domanda) apriChiudi(domanda.closest('.faq-item'));
    else if (risposta) apriChiudi(risposta.closest('.faq-item'));
    else if (item) apriChiudi(item);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-info-taglia-lunghezza"]) return;
  try {
    
  const popupInfo = document.getElementById('popup-info-lunghezza');
  const iconInfoBtn = document.getElementById('icon-info-btn-lunghezza');
  const popupClose = document.querySelector('.popup-close-lunghezza');

  if (iconInfoBtn && popupInfo && popupClose) {
    iconInfoBtn.addEventListener('click', function () {
      popupInfo.hidden = false;
    });

    popupClose.addEventListener('click', function () {
      popupInfo.hidden = true;
    });

    popupInfo.addEventListener('click', function (e) {
      if (e.target === popupInfo) popupInfo.hidden = true;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
